<div class="container p-3">
    <div class="row">
        <div class="col position-relative">
            <div style="position: absolute; top: 0px; right: 15px;">
                <button class="btn btn-primary" (click)="refreshFirmwares()">
                    <i class="fas fa-sync-alt"></i> Refresh
                </button>
            </div>
            <div>
                <h3>Select product</h3>
                <div class="row">
                    <div class="col-auto mb-3">
                        <select #productSelectControl class="form-select" (change)="selectProduct(productSelectControl.value)">
                            <option value="undefined">―</option>
                            <option *ngFor="let product of products" value="{{ product.name }}" [selected]="selectedProduct?.name == product.name">{{ product.name }}</option>
                        </select>
                    </div>
                    <div class="col-auto mb-3" *ngIf="selectedProduct">
                        <select #apiSelectControl class="form-select" (change)="selectApi(apiSelectControl.value)">
                            <option *ngFor="let api of selectedProduct.api" value="{{ api }}" [selected]="selectedApi == api">{{ api }}</option>
                        </select>
                    </div>
                </div>
                <div *ngIf="selectedApi == 'v2' && selectedProduct.name == 'MyScale'">
                    <firmware-v2-myscale [product]="selectedProduct"></firmware-v2-myscale>
                </div>
                <div *ngIf="selectedApi == 'v2' && selectedProduct.name != 'MyScale'">
                    <firmware-v2 [product]="selectedProduct"></firmware-v2>
                </div>
                <div *ngIf="selectedApi == 'v1'">
                    <firmware-v1 [product]="selectedProduct"></firmware-v1>
                </div>
            </div>
        </div>
    </div>
</div>